module.exports = __webpack_public_path__ + "static/img/znzz1.6d869a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/znzz1.jpg
// module id = x1Cy
// module chunks = 0